import { createStore } from 'satcheljs';
export default createStore('inlinePreviewOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map